
import { mapActions } from 'vuex'
import VueSkeletonLoader from 'skeleton-loader-vue'
import { parseReviewsBreakdown } from '~/helpers/stamped/parseReviewsBreakdown'
import SvgStarEmpty from '~/assets/svg/star-empty.svg?inline'
import SvgStarHalf from '~/assets/svg/star-half.svg?inline'
import SvgStarFilled from '~/assets/svg/star-filled.svg?inline'

export default {
  name: 'StampedReviews',
  components: { SvgStarEmpty, SvgStarHalf, SvgStarFilled, VueSkeletonLoader },
  inject: ['product', 'wording'],
  props: {
    embedded: {
      type: Boolean,
      required: false,
      default: false,
    },
    reviewsBreakdown: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      product: this.product,
      wording: this.wording,
    }
  },
  computed: {
    reviewObjectReady() {
      return this.reviewsBreakdown && this.reviewsBreakdown.length
    },
    reviewsBreakdownParsed() {
      if (this.reviewObjectReady) {
        return parseReviewsBreakdown(this.reviewsBreakdown)
      } else return null
    },
    globalReviewsCount() {
      if (this.reviewObjectReady) {
        return this.reviewsBreakdownParsed.global.count
      } else return null
    },
    globalReviewsRating() {
      if (this.reviewObjectReady) {
        return this.reviewsBreakdownParsed.global.rating
      } else return null
    },
    averageScoreFloat() {
      if (this.reviewObjectReady) {
        return parseFloat(this.globalReviewsRating).toFixed(1)
      } else return null
    },
    averageScoreInt() {
      if (this.reviewObjectReady) {
        return parseInt(this.globalReviewsRating)
      } else return null
    },
  },
  methods: {
    ...mapActions({
      vxSetLeaveReviewIntent: 'pdp/setLeaveReviewIntent',
    }),
    scrollToReviews(intent) {
      if (intent === 'leaveReview') {
        this.vxSetLeaveReviewIntent(true)
      }
      document.getElementById('reviews').scrollIntoView({ behavior: 'smooth' })
    },
  },
}
